import { Action } from "redux"

import * as actions from "./actions"
import { IAddin, IAddins } from "./index"

export const initialState: IAddins = {
    addins: [],
    isLoading: false,
}

const handlers: {
    [action: string]: (state: IAddins, props: Action) => IAddins
} = {
    [actions.REQUEST_ADDINS]: (state): IAddins => ({
        ...state,
        isLoading: true,
    }),
    [actions.RECEIVE_ADDINS]: (
        state,
        { addins }: actions.ReceiveAddinsAction,
    ): IAddins => ({
        ...state,
        addins: addins.map((addin: IAddin) => ({
            addInName: addin.addInName,
            addInId: addin.addInId,
            addInVersion: addin.addInVersion,
            diff: {
                lastChangeTime: addin.diff.lastChangeTime,
                installationTime: addin.diff.installationTime,
                changes: addin.diff.changes,
            },
        })),
        isLoading: false,
    }),
}

export default function reducer(
    state: IAddins = initialState,
    action: Action,
): IAddins {
    const handler: (state: IAddins, action: Action) => IAddins =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
